import type { FC, ReactNode } from "react";
import type { PartialDeep } from "type-fest";
import type { SearchDataModel } from "@searchui-searchforms/shared/canonicalizer";
import { createSafeContext } from "@/shared/utils/createSafeContext";
import { useNormalizedDataModel } from "./useNormalizedDataModel";

const [InternalProvider, useDataModelContext] = createSafeContext<SearchDataModel>("DataModelContext");

const DataModelProvider: FC<{
    value: PartialDeep<SearchDataModel> | undefined;
    children: ReactNode;
}> = ({ value = {}, children }) => {
    const normalized = useNormalizedDataModel(value);
    return <InternalProvider value={normalized}>{children}</InternalProvider>;
};

export { DataModelProvider, useDataModelContext };
